export default __webpack_public_path__ + "static/media/AdgileBolt_RGB_White.fa2eba90.png";